import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { SubscriptionItemQuantityEvent } from 'src/features/subscriptionItemQuantityEvents/utils/types';

const RESOURCE = '/subscriptions/subscription-item-quantity-event/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    subscription_item: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<SubscriptionItemQuantityEvent>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export {
    RESOURCE as LIST_SUBSCRIPTION_ITEM_QUANTITY_EVENTS_RESOURCE,
    useQueryHook as useListSubscriptionItemQuantityEvents,
};
